import { isAxiosError } from 'axios'

import { ASKED_RATHER_THAN_FAILED } from '@brickup/shared/constants'
import { codedErrorText } from '@brickup/shared/locales/de/server-errors'

/**
 * Pull a user-presentable message out of an axios error.
 *
 * A structured `{ code, ...params }` body selects German text through
 * `codedErrorText`, which owns what the envelope's own fields are. Everything
 * else falls back to the German string the caller supplied.
 *
 * The envelope's own `message` is not shown. It is English — a fallback for
 * consumers that read the response raw, logs and any client that is not this
 * app. A failure the user should be able to act on needs a `ServerErrorCode`;
 * without one, the caller's German fallback is what they see.
 */
export function extractErrorMessage(err: unknown, fallback: string): string {
  return (isAxiosError(err) && codedErrorText(err.response?.data)) || fallback
}

/**
 * Whether this failure is a question the screen is going to ask.
 *
 * A refusal that carries what the write would do is answered by calling again,
 * so the surface renders it as a dialog — and a snackbar beside that dialog
 * states the same thing a second time, as something that went wrong. The one
 * reader is the shared mutation handler, so no call site has to remember.
 */
export function isAskedRatherThanFailed(error: unknown): boolean {
  if (!isAxiosError(error)) return false
  const code = (error.response?.data as { code?: string } | undefined)?.code
  return ASKED_RATHER_THAN_FAILED.some(asked => asked === code)
}
